import AModalFooter from './index.vue';

AModalFooter.install = app => {
  app.component(AModalFooter.name, AModalFooter);
};

export default AModalFooter;
